import { render, staticRenderFns } from "./AssemblyEdit.vue?vue&type=template&id=1377d5ec&scoped=true"
import script from "./AssemblyEdit.vue?vue&type=script&lang=js"
export * from "./AssemblyEdit.vue?vue&type=script&lang=js"
import style0 from "./AssemblyEdit.vue?vue&type=style&index=0&id=1377d5ec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1377d5ec",
  null
  
)

export default component.exports